import React from 'react'
import MovingComponent from 'react-moving-text'
import MovingComponent1 from 'react-moving-text'
import MovingComponent2 from 'react-moving-text'

const Letters = ["B","A","E","S","-","S","T","U","D","I","O"]


function MyAnimatedTypo() {
  return (
  <MovingComponent2
    type="fadeOutToTop"
    duration="800ms"
    delay="0s"
    direction="alternate-reverse"
    timing="ease"
    iteration="1"
    fillMode="forwards">
    BAES STUDIO
  </MovingComponent2>
  )
}

function MyAnimatedTypo1() {
  return (
    Letters.map((letter, index) =>
    <MovingComponent key={index}
      type="bounce"
      duration="400ms"
      delay= {index * 100 + "ms"}
      direction="normal"
      timing="ease"
      iteration="1"
      fillMode="none">
      {letter}
    </MovingComponent>)
  )
}

function MyAnimatedTypo2({textvalue}){
  return (
  <MovingComponent2
    type="fadeOutToTop"
    duration="800ms"
    delay="0s"
    direction="alternate-reverse"
    timing="ease"
    iteration="1"
    fillMode="forwards">
    {textvalue}
  </MovingComponent2>
  )
}

export {MyAnimatedTypo,MyAnimatedTypo2};
